<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group row align-items-center">

        <!-- HEADER -->
        <label class="h4 col-sm-12">Declaration by Applicant</label>

        <!-- MAIN BODY -->
        <label class="col-sm-12 mb-sm-0">
          I confirm that the information I have provided in this application is complete, accurate, and truthful to the best of my knowledge.
          I understand that any false statement, misrepresentation, or omission may result in withdrawal of any job offer, termination of employment, and may constitute a criminal offence.

          <br><br>
          I understand and accept that my application is subject to screening in accordance with BS7858:2019, and that I may be required to undergo the following checks:
          <ul>
            <li>Identity verification and address history checks</li>
            <li>Financial probity checks (credit reference)</li>
            <li>Employment history and gap verification</li>
            <li>Academic and professional qualifications verification</li>
            <li>Criminal record disclosure check</li>
            <li>Right to work and immigration status verification</li>
          </ul>

          <br>
          I authorise {{ companyInfo.company_name }} and its appointed agents to:
          <ul>
            <li>Contact current and previous employers, educational institutions, and personal referees</li>
            <li>Verify periods of employment, self-employment, unemployment, and address history</li>
            <li>Conduct financial, criminal record, and right-to-work checks</li>
            <li>Request and retain screening information where required for legal or contractual obligations</li>
          </ul>

          <br>
          I understand that:
          <ul>
            <li>All data provided is processed in accordance with the UK GDPR, Data Protection Act 2018, and the company’s Privacy Notice</li>
            <li>I have the right to access, rectify, or withdraw consent to processing unless restricted by law</li>
            <li>My data will be retained for the periods defined in the company’s Screening Data Retention Schedule</li>
            <li>I may be required to complete a medical assessment or drug test, if applicable to the role</li>
            <li>I will notify the company and relevant authorities if I am currently unemployed and accept employment</li>
          </ul>

          <br>
          If applicable, I accept that I am responsible for maintaining a valid SIA licence and will notify {{ companyInfo.company_name }} of any changes to my contact details or legal status.

          <br><br>
          <strong>By signing below, I confirm that I:</strong>
          <ul>
            <li>Have read and understood the company’s Privacy Notice and this declaration</li>
            <li>Consent to the processing of my data for the purposes outlined above</li>
            <li>Understand that employment is subject to satisfactory screening and compliance with all pre-employment conditions</li>
          </ul>
        </label>

        <!-- CONSENT CHECKBOX -->
        <label class="col-sm-12 mb-sm-0">I Agree to the Above Terms and Conditions</label>
        <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                   type="single-checkbox"
                   :list-value-field="$t('I Agree')"
                   v-model="policy_declaration.applicant_screening"
                   placeholder="" />
      </div>
    </form>
  </div>
</template>


<script>
import {FormMixin} from "@/core/mixins/form/FormMixin";

export default {
  name: "PolicyDeclaration",
  mixins: [FormMixin],
  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    policy_declaration: {
      type: Object,
      default: () => ({})
    },
    companyInfo: {
      type: Object,
      default: () => ({})
    },
    yesOrNoList: {
      type: Array
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created(){
    this.$hub.$emit("candidateDetailActiveIndex", 9);

  },
  methods: {}
};
</script>